import { ScrollButtons } from 'thalia-elements/modules/lists/scroll-buttons/main.js';

class SliderBubble extends HTMLElement {
    constructor() {
        super();
        this.scrollButtons = null;
    }

    connectedCallback() {
        const liste = this.querySelector('.bubble-list');
        if (!liste) {
            return;
        }
        this.scrollButtons = new ScrollButtons(liste);
        this.scrollButtons.init();
    }

    disconnectedCallback() {
        this.scrollButtons?.destroy();
    }
}

if (!customElements.get('slider-bubble')) {
  customElements.define('slider-bubble', SliderBubble);
}
